import httpClient from '../axios/index';
var myHeaders = new Headers();
myHeaders.append('Referer', 'http://11925.localhost:3000');
myHeaders.append(
  'Authorization',
  'Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJMb2dnZWRVc2VySWQiOiIxNWIxNzJmMC1kNGZkLTQ3MjgtYjM0NS04NDZlZTFkMDdjMmYiLCJMb2dnZWRVc2VyUm9sZSI6ImFkbWluIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiYWRtaW4iLCJQdWJsaXNoZXJJZCI6ImNhNmZlY2Y5LTJjNmUtMTFlMy05ZDIwLTIyMDAwYTljZTA2MCIsIlB1Ymxpc2hlck51bWJlciI6IjExOTI1IiwiUHVibGlzaGVyTmFtZSI6ImFzYWZndSIsIlB1Ymxpc2hlckVtYWlsIjoiYXNhZmd1QGdtYWlsLmNvbSIsIlB1Ymxpc2hlcklzQWN0aXZlIjoiVHJ1ZSIsIlB1Ymxpc2hlcklzQmxvY2tlZCI6IkZhbHNlIiwiZXhwIjoxNjg2MDI4OTU1LCJpc3MiOiJ3d3cuYXBwbmV4dC5uZXQiLCJhdWQiOiJ3d3cuYXBwbmV4dC5uZXQifQ.bPYKU__d0PETfcQuKUABTkAEebns7WsP59112UZaEVI',
);

class CreativesDataService {
  package_id = 'com.waze';
  pba_id = '47e10799-ce5c-4393-b1f5-90020e0a7001';
  getCreativesDetails(id) {
    return httpClient.get(`/api/Creative/GetCreativesList?creativesCampaignId=${id}`);
  }

  loadCreativeAndTrackingData(reqDataObj) {
    return httpClient.get(
      `api/Creative/LoadCreativeAndTrackingData?pba_id=${reqDataObj?.pba_id}&cm_id=${reqDataObj?.cm_id}`,
    );
  }

  uploadVideo(file, creativeModalType, package_id, pba_id, fileName) {
    console.log('uploadVideo', file);
    console.log('package_id', package_id);
    console.log('creativeModalType', creativeModalType);
    let videoType = 0; //  portrait = 0, landscape = 1
    if (creativeModalType === 'video_landscape') {
      videoType = 'landscape';
    }
    if (creativeModalType === 'video_portrait') {
      videoType = 'portrait';
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('videoName', fileName);
    formData.append('videoType', videoType);
    formData.append('pba_id', pba_id);
    formData.append('package_id', package_id);
    formData.append('file', file);
    return httpClient.post(`/api/Creative/UploadVideo`, formData);
  }

  RemoveCreativeImage(imageId) {
    console.log('deleteCreativeImage!!!!!!!', imageId);
    return httpClient.post(`/api/Creative/RemoveCreativeImage?imageId=${imageId} `);
  }
  RemoveCreativeVideo(vidoeId) {
    console.log('RemoveCreativeVideo!!!!!!!', vidoeId);
    return httpClient.post(`/api/Creative/RemoveCreativeVideo?vidoeId=${vidoeId} `);
  }
}

export default new CreativesDataService();
